/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Scl_Log_Toast_AdjustedInputs */

const vi_scl_log_toast_adjusted = /** @type {(inputs: Scl_Log_Toast_AdjustedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã tạo ${i?.n} phiếu điều chỉnh, đang chờ duyệt`)
};

/**

* @param {Scl_Log_Toast_AdjustedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_log_toast_adjusted = /** @type {((inputs: Scl_Log_Toast_AdjustedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Log_Toast_AdjustedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_log_toast_adjusted(inputs)
});